import React, { FC } from 'react';
import { Keyboard, Pressable, TextInput, View } from 'react-native';

import { Body1Reg, Title3, mainTypoRegular } from '../../../config/designSystem/typography';
import { COLORS } from '../../../config/designSystem/Colors';
import { InfoCard } from '../ui/InfoCard';
import { JournalEntryData } from './ContainJournalEntry';
import { QuestionSessionBodyPresentationProps } from '../../QuestionSessions/QuestionSessionBody/config';
import { SPACING } from '../../../config/designSystem/Spacing';
import { isWeb } from '../../../config/designSystem/Layout';
import { useDiaryMaxWidth } from '../ui/useDiaryMaxWidth';

/**
 * figma: Journaling entry frame (Activities & Challenges pt1)
 * Centered title with accent divider, large entry field and an optional
 * helper card.
 */
export const PresentJournalEntry: FC<QuestionSessionBodyPresentationProps> = ({
  questionText,
  data,
}) => {
  const maxWidth = useDiaryMaxWidth();
  const journal = (data || {}) as JournalEntryData;

  return (
    // the multiline field has no Done key and the session frame is not a
    // ScrollView: without an explicit escape the keyboard covers Finish and
    // traps the user — tapping anywhere around the field dismisses it.
    // flexGrow stretches the dismiss zone over the dead space below the
    // field too (a no-op when the parent gives no extra room)
    <Pressable onPress={isWeb ? undefined : Keyboard.dismiss} accessible={false} style={{ flexGrow: 1, alignItems: 'center', paddingHorizontal: SPACING['sp-16'] }}>
      <View style={{ width: '100%', maxWidth, rowGap: SPACING['sp-24'] }}>
        <View style={{ rowGap: SPACING['sp-16'], alignItems: 'center' }}>
          <Title3 align={true}>{questionText}</Title3>
          <View
            style={{ width: 90, height: 3, borderRadius: 2, backgroundColor: COLORS.content.accent }}
          />
        </View>
        <TextInput
          value={journal.value}
          onChangeText={journal.onChangeText}
          multiline={true}
          style={{
            minHeight: 220,
            backgroundColor: COLORS.surface.contrast,
            borderRadius: SPACING['sp-12'],
            borderWidth: 1,
            borderColor: COLORS.border.secondary,
            padding: SPACING['sp-16'],
            fontFamily: mainTypoRegular,
            fontSize: 16,
            lineHeight: 22,
            color: COLORS.content.primary,
            textAlignVertical: 'top',
          }}
        />
        {journal.infoTitle && journal.infoBody ? (
          <InfoCard title={journal.infoTitle} body={journal.infoBody} />
        ) : journal.infoTitle ? (
          <Body1Reg color={COLORS.content.secondary}>{journal.infoTitle}</Body1Reg>
        ) : null}
      </View>
    </Pressable>
  );
};
